(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__robeviaDiscountBadge) return;
    window.__robeviaDiscountBadge = true;

    function formatMoney(cents) {
      var format = (window.Shopify && window.Shopify.money_format) || window.__robeviaMoneyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
        if (key === 'amount_with_comma_separator') return value.replace('.', ',');
        return value;
      });
    }

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var variant = detail.resource;
      var productId = detail.data && detail.data.productId;
      if (!variant || !productId) return;

      var badges = document.querySelectorAll('[data-discount-badge][data-product-id="' + productId + '"]');
      if (!badges.length) return;

      var price = Number(variant.price);
      var compare = Number(variant.compare_at_price || 0);

      badges.forEach(function (badge) {
        var text = badge.querySelector('[data-discount-badge-text]');
        if (compare > price) {
          var savings = compare - price;
          var percent = Math.round((savings * 100) / compare);
          if (text) text.textContent = percent + '% Off | Save ' + formatMoney(savings);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
